import { bossiteUsersRestClient } from 'helpers/restclient';
import { getDiscountsSortingApiParams } from 'store/slices/dealDriver/goodwill/helpers';
import { applyParams, verifyDealershipIdParam } from './applyParams';

const ADMIN_API_PREFIX = '/api/admin';

export default class GoodwillService {
	static instance = new GoodwillService();

	_endpoints = {
		updateApprovalRequest: (bidSaleId, requestId) =>
			`${ADMIN_API_PREFIX}/bid_sales/${bidSaleId}/approval_requests/${requestId}`,
		getAll: `${ADMIN_API_PREFIX}/bid_sales/approval_requests`,
		tracks: `${ADMIN_API_PREFIX}/goodwill_tracks`,
	};

	constructor() {
		this.restClient = bossiteUsersRestClient;
	}

	updateApprovalRequest = (
		bidSaleId,
		requestId,
		isApproved = false,
		isDenied = false,
		acknowledged = false,
		denialReason = null,
	) => {
		const endpoint = this._endpoints.updateApprovalRequest(bidSaleId, requestId);
		const payload = {};

		applyParams(
			{
				approved: isApproved,
				denied: isDenied,
				acknowledged,
				denial_reason: denialReason,
			},
			payload,
		);

		return this.restClient.put(endpoint, payload);
	};

	getAll = (config = {}) => {
		const endpoint = this._endpoints.getAll;
		const sortingParams = getDiscountsSortingApiParams(config.sorting);
		const payload = {
			page: config.page || 1,
			...sortingParams,
		};

		const filtersWithoutPage = { ...(config.filters ?? {}) };
		delete filtersWithoutPage.page;

		applyParams(filtersWithoutPage, payload);
		verifyDealershipIdParam(config.filters, payload);

		return this.restClient.get(endpoint, payload);
	};

	eventTracking = (params) => {
		const endpoint = this._endpoints.tracks;

		return this.restClient.post(endpoint, params);
	};
}
